import { Component, OnInit, ViewChild } from "@angular/core";
import { CandidateService } from "../../service/candidate/candidate.service";
import { Candidate } from "../../class/candidate";
import {
  FormGroup,
  AbstractControl,
  FormBuilder,
  Validators,
  FormControl,
  ValidationErrors,
} from "@angular/forms";
import {
  Message,
  ConfirmationService,
  LazyLoadEvent,
  SelectItem,
  CalendarModule,
  ToggleButtonModule,
} from "primeng/primeng";
import { TranslateService } from "@ngx-translate/core";
import { ActivatedRoute, Route, Router } from "@angular/router";
import { HasPermissionService } from "../../service/has-permission/has-permission.service";
import { config } from "../../../../../environments/config";
import { formatDate } from "../../../../theme/functions/formatDate.function";
import { calendarES } from "../../../../theme/functions/calendarES";
import { CandidateEducationLevelOptions } from "../../../../shared/constans";

@Component({
  selector: "app-candidates",
  templateUrl: "./candidates.component.html",
  styleUrls: ["./candidates.component.scss"],
})
export class CandidatesComponent implements OnInit {
  @ViewChild("gb") searchFilter;

  public promiseForm: Promise<any>;
  public msgs: Message[] = [];
  public candidate: Candidate[];
  public selectCandidate: Candidate;
  public candidateID: Number = 0;
  public modNew = false;
  public modView = false;
  public modViewDialog = false;
  public openCandidate = false;
  public totalRecords: number;
  public page: number;
  public per_page: number;
  public sort: string;
  public query: string;
  public with: string;
  public with_count: string;
  public candidatePosition: string;
  public filters: { key: string; value: string }[];

  public modExportDialog: boolean;

  public form4: FormGroup;
  public f4_date_start: AbstractControl;
  public f4_date_end: AbstractControl;
  public f4_candidate_source: AbstractControl;

  public apiUrl = config.API_ROOT;
  public es: any;
  public loading: boolean = true;
  // public professionOptions: SelectItem[];

  public first = 0;

  public genderOptions: any[];
  public civilStatusOptions: any[];
  public drivingLicenseOptions: any[];
  public levelEducationOptions: any[] = CandidateEducationLevelOptions;

  public form_filter: FormGroup;

  public form: FormGroup;
  public read: AbstractControl;
  public modNewViewDialog = false;

  public barcodeRead: string;

  public SMMLV: number = 1750905;

  public salaryAspirationOptions: any[];
  public ageMinOptions: any[];
  public ageMaxOptions: any[];
  public ageMin: number = 18;
  public ageMax: number = 70;

  public createdByBotzyOptions: any[];
  public candidateSourceOptions: any[];
  public employee_id_botzy: string = "11178";

  public jobStatusOptions: any[];

  public candidateHasUserOptions: any[];
  public candidateHasWorkExperienceOptions: any[];

  constructor(
    public candidateService: CandidateService,
    public confirmationService: ConfirmationService,
    public translate: TranslateService,
    public hasPermissionService: HasPermissionService,
    public router: Router,
    public fb: FormBuilder
  ) {
    this.salaryAspirationOptions = [
      {
        label: "Entre 0 a 1 SMMLV",
        value: "Entre 0 a 1 SMMLV",
        min: 0 * this.SMMLV,
        max: 1 * this.SMMLV,
      },
      {
        label: "Entre 1 a 2 SMMLV",
        value: "Entre 1 a 2 SMMLV",
        min: 1 * this.SMMLV,
        max: 2 * this.SMMLV,
      },
      {
        label: "Entre 2 a 3 SMMLV",
        value: "Entre 2 a 3 SMMLV",
        min: 2 * this.SMMLV,
        max: 3 * this.SMMLV,
      },
      {
        label: "Entre 3 a 4 SMMLV",
        value: "Entre 3 a 4 SMMLV",
        min: 3 * this.SMMLV,
        max: 4 * this.SMMLV,
      },
      {
        label: "Entre 4 a 5 SMMLV",
        value: "Entre 4 a 5 SMMLV",
        min: 4 * this.SMMLV,
        max: 5 * this.SMMLV,
      },
      {
        label: "Más de 5 SMMLV",
        value: "Más de 5 SMMLV",
        min: 5 * this.SMMLV,
        max: 100 * this.SMMLV,
      },
    ];

    this.ageMinOptions = [];
    this.ageMaxOptions = [];

    for (let i = this.ageMin; i <= this.ageMax; i++)
      this.ageMinOptions.push({ label: i.toString() + " años", value: i });

    for (let i = this.ageMin; i <= this.ageMax; i++)
      this.ageMaxOptions.push({ label: i.toString() + " años", value: i });

    this.genderOptions = [
      { label: "Femenino", value: "Femenino", code_sorttime: "SEXFEM" },
      { label: "Masculino", value: "Masculino", code_sorttime: "SEXHOM" },
      { label: "No binario", value: "No binario", code_sorttime: "SEXBIN" },
    ];

    this.civilStatusOptions = [
      { label: "Soltero(a)", value: "Soltero(a)", code_sorttime: "ECVSOL" },
      { label: "Unión libre", value: "Unión libre", code_sorttime: "ECVLIB" },
      { label: "Casado(a)", value: "Casado(a)", code_sorttime: "ECVCAS" },
      {
        label: "Divorciado(a)",
        value: "Divorciado(a)",
        code_sorttime: "ECVDIV",
      },
      { label: "Separado(a)", value: "Separado(a)", code_sorttime: "ECVSEP" },
      { label: "Viudo(a)", value: "Viudo(a)", code_sorttime: "ECVVIU" },
    ];

    this.drivingLicenseOptions = [
      { label: "Sí", value: "Sí", code_sorttime: "Sí" },
      { label: "No", value: "No", code_sorttime: "No" },
    ];

    /* this.professionOptions = [
        {label: 'Seleccione' , value: ''},
        {label: 'Administración / Oficina' , value: 'Administración / Oficina'},
        {label: 'Almacén / Logística' , value: 'Almacén / Logística'},
        {label: 'Atención a clientes' , value: 'Atención a clientes'},
        {label: 'CallCenter / Telemercadeo' , value: 'CallCenter / Telemercadeo'},
        {label: 'Compras / Comercio Exterior' , value: 'Compras / Comercio Exterior'},
        {label: 'Construccion y obra' , value: 'Construccion y obra'},
        {label: 'Contabilidad / Finanzas' , value: 'Contabilidad / Finanzas'},
        {label: 'Dirección / Gerencia' , value: 'Dirección / Gerencia'},
        {label: 'Diseño / Artes gráficas' , value: 'Diseño / Artes gráficas'},
        {label: 'Docencia' , value: 'Docencia'},
        {label: 'Hotelería / Turismo' , value: 'Hotelería / Turismo'},
        {label: 'Informática / Telecomunicaciones' , value: 'Informática / Telecomunicaciones'},
        {label: 'Ingeniería' , value: 'Ingeniería'},
        {label: 'Investigación y Calidad' , value: 'Investigación y Calidad'},
        {label: 'Legal / Asesoría' , value: 'Legal / Asesoría'},
        {label: 'Mantenimiento y Reparaciones Técnicas' , value: 'Mantenimiento y Reparaciones Técnicas'},
        {label: 'Marketing Digital' , value: 'Marketing Digital'},
        {label: 'Medicina / Salud' , value: 'Medicina / Salud'},
        {label: 'Mercadeo / Publicidad / Comunicación' , value: 'Mercadeo / Publicidad / Comunicación'},
        {label: 'Márketing / Ventas' , value: 'Márketing / Ventas'},
        {label: 'Producción / Operaciones' , value: 'Producción / Operaciones'},
        {label: 'Recursos Humanos' , value: 'Recursos Humanos'},
        {label: 'Servicios Generales, Aseo y Seguridad' , value: 'Servicios Generales, Aseo y Seguridad'},
        {label: 'Veterinaria / Zootecnia' , value: 'Veterinaria / Zootecnia'},
        {label: 'Conductor / Logística' , value: 'Conductor / Logística'},
        {label: 'Mensajero' , value: 'Mensajero'},
        {label: 'Otro (He Leído Los Demás)' , value: 'Otro'},
    ]; */

    this.candidateSourceOptions = [
      { label: "Creados por Botzy", value: "Si" },
      { label: "No creados por Botzy", value: "No" },
    ];

    this.createdByBotzyOptions = [
      { label: "Sí", value: "Si" },
      { label: "No", value: "No" },
    ];

    this.jobStatusOptions = [
      { label: "Sí", value: true },
      { label: "No", value: false },
    ];

    this.candidateHasUserOptions = [
      { label: "Sí", value: true },
      { label: "No", value: false },
    ];
    this.candidateHasWorkExperienceOptions = [
      { label: "Sí", value: true },
      { label: "No", value: false },
    ];

    this.modExportDialog = false;
    this.form4 = fb.group({
      f4_date_start: ["", [Validators.required]],
      f4_date_end: ["", [Validators.required]],
      f4_candidate_source: [""],
    });
    this.f4_date_start = this.form4.controls["f4_date_start"];
    this.f4_date_end = this.form4.controls["f4_date_end"];
    this.f4_candidate_source = this.form4["f4_candidate_source"];

    this.es = calendarES();

    this.form = fb.group({
      read: ["", Validators.compose([Validators.minLength(1)])],
    });
    this.read = this.form.controls["read"];
  }

  ngOnInit() {
    // if (this.route.snapshot.url[0].path === 'management-claro')  {
    //     if (this.route.snapshot.url[1].path === 'auxiliar')  {
    //         this.candidatePosition = '2';
    //         this.filters = [];
    //         this.filters.push({key: 'candidate_position_id', value: this.candidatePosition});
    //     }
    // } else {
    //     if (this.route.snapshot.url[0].path === 'selection')  {
    //         if (this.route.snapshot.url[1].path === 'psychologist')  {
    //             this.candidatePosition = '3';
    //             this.filters = [];
    //             this.filters.push({key: 'candidate_position_id', value: this.candidatePosition});
    //         }
    //     }
    // }
    this.query = undefined;
    this.page = 1;
    this.per_page = 10;
    this.with_count = "education,work_experience,candidate_comment";
    this.with = "residence_city_name,profession_name";
    // this.with +='citation.document_profile_survey,citation.requisition_candidate.company,citation.requisition_candidate.profile_survey,citation.requisition_candidate.venue';

    // this.sort = '-id';
    this.sort = "-updated_at";

    // this.getCandidate(this.query);

    this.createFormFilter(null);
  }

  createFormFilter(data: any = null) {
    data = data || {
      gender_filter: "",
      civil_status_filter: "",
      driving_license_filter: "",
      level_education_filter: "",
      residence_city_id_filter: null,
      salary_aspiration_filter: "",
      age_min_filter: "",
      age_max_filter: "",
      created_botzy_filter: "",
      job_status_filter: "",
      candidate_has_user_filter: "",
      profession_id_filter: null,
      candidate_has_work_experience_filter: "",
      work_area_filter: null,
    };

    this.form_filter = this.fb.group({
      gender_filter: new FormControl(data.gender_filter),
      civil_status_filter: new FormControl(data.civil_status_filter),
      driving_license_filter: new FormControl(data.driving_license_filter),
      level_education_filter: new FormControl(data.level_education_filter),
      residence_city_id_filter: new FormControl(data.residence_city_id_filter),
      salary_aspiration_filter: new FormControl(data.salary_aspiration_filter),
      age_min_filter: new FormControl(data.age_min_filter),
      age_max_filter: new FormControl(data.age_max_filter),
      created_botzy_filter: new FormControl(data.created_botzy_filter),
      job_status_filter: new FormControl(data.job_status_filter),
      candidate_has_user_filter: new FormControl(
        data.candidate_has_user_filter
      ),
      candidate_has_work_experience_filter: new FormControl(
        data.candidate_has_work_experience_filter
      ),
      profession_id_filter: new FormControl(data.profession_id_filter),
      work_area_filter: new FormControl(data.work_area_filter),
    });
  }

  public loadCandidateLazy(event: LazyLoadEvent) {
    this.page = event.first / this.per_page + 1;
    if (event.sortField) {
      if (event.sortOrder === -1) {
        this.sort = "-" + event.sortField;
      } else {
        this.sort = event.sortField;
      }
    } else {
      this.sort = "-updated_at";
    }

    this.buildingFilter(this.form_filter.value);

    this.getCandidate(event.globalFilter);
  }

  getCandidate(query?: string) {
    this.loading = true;
    this.candidateService
      .getCandidate(
        this.page,
        this.per_page,
        this.sort,
        query,
        this.filters,
        this.with,
        this.with_count
      )
      .toPromise()
      .then(
        (response) => {
          this.loading = false;
          this.candidate = response.json().data;
          if (
            response.json().meta.total > response.json().meta.total_filtered
          ) {
            this.totalRecords = response.json().meta.total_filtered;
          } else {
            this.totalRecords = response.json().meta.total;
          }
        },
        (error) => {
          this.loading = false;
          this.msgs = [];
          this.msgs.push({ severity: "error", summary: "error" });
        }
      );
  }

  getCandidateEducationSearch(query?: string, filters?: any[]) {
    this.candidateService
      .getCandidateByEducation(
        this.page,
        this.per_page,
        this.sort,
        query,
        filters
      )
      .toPromise()
      .then(
        (response) => {
          this.candidate = [];
          response.json().data.forEach((element) => {
            this.candidate.push(element.candidate);
          });
          if (
            response.json().meta.total > response.json().meta.total_filtered
          ) {
            this.totalRecords = response.json().meta.total_filtered;
          } else {
            this.totalRecords = response.json().meta.total;
          }
        },
        (error) => {
          this.msgs = [];
          this.msgs.push({ severity: "error", summary: "error" });
        }
      );
  }

  getCandidateWorkExperienceSearch(query?: string, filters?: any[]) {
    this.candidateService
      .getCandidateByWorkExperience(
        this.page,
        this.per_page,
        this.sort,
        query,
        filters
      )
      .toPromise()
      .then(
        (response) => {
          this.candidate = [];
          response.json().data.forEach((element) => {
            this.candidate.push(element.candidate);
          });
          if (
            response.json().meta.total > response.json().meta.total_filtered
          ) {
            this.totalRecords = response.json().meta.total_filtered;
          } else {
            this.totalRecords = response.json().meta.total;
          }
        },
        (error) => {
          this.msgs = [];
          this.msgs.push({ severity: "error", summary: "error" });
        }
      );
  }

  public newCandidate() {
    this.modNew = !this.modNew;
    this.selectCandidate = null;
  }

  public savedCandidate(res) {
    this.msgs = [];
    this.msgs.push(res);
    this.selectCandidate = null;
    this.modNew = false;
    // this.getCandidate();//Comentado porque existe componente y se quita y detecta load_lazy
  }

  public cancelCandidate(res) {
    this.selectCandidate = null;
    this.modNew = false;
    this.modView = false;
    //this.getCandidate();//Comentado porque existe componente y se quita y detecta load_lazy
  }

  public edit(candidate: Candidate) {
    this.modNew = true;
    this.selectCandidate = candidate;
    this.getCandidate();
  }

  public view(candidate: Candidate) {
    this.openCandidate = true;
    this.selectCandidate = candidate;
    this.candidateID = candidate.id;
    this.modView = true;
  }

  public viewDialog(candidate: Candidate) {
    this.openCandidate = true;
    this.selectCandidate = candidate;
    this.candidateID = candidate.id;
    this.modViewDialog = true;
  }
  public viewCurriculum(candidate_id: number) {
    const token = localStorage.getItem("token");
    const url = `${this.candidateService.apiUrl}/documents-by-candidate/${candidate_id}?token=${token}`;
    window.open(url, "_blank");
  }
  public showExportDialog() {
    this.modExportDialog = true;
  }

  public cancelExport() {
    this.modExportDialog = false;
  }
  public exportReportExcel(values) {
    let d = new Date(values.f4_date_start);
    d.setHours(0);
    d.setMinutes(0);
    d.setSeconds(0);
    d.setMilliseconds(0);

    const f4_date_start = formatDate(d);

    d = new Date(values.f4_date_end);
    d.setHours(23);
    d.setMinutes(59);
    d.setSeconds(59);
    d.setMilliseconds(59);
    const f4_date_end = formatDate(d);

    let url =
      this.apiUrl +
      "/candidates/excel?" +
      "token=" +
      localStorage.getItem("token") +
      "&_page=1&_limit=100000&_sort=-id" +
      "&created_at-min=" +
      f4_date_start +
      "&created_at-max=" +
      f4_date_end;

    if (values.f4_candidate_source) {
      url = url + "&created_by_botzy=" + values.f4_candidate_source + "&";
    }

    window.open(url, "_blank");
  }

  public deleteDialog(candidate: Candidate) {
    let message;
    this.translate.get("Do you want to delete?").subscribe((res: string) => {
      message = res;
    });

    let header;
    this.translate.get("Delete Confirmation").subscribe((res: string) => {
      header = res;
    });

    this.confirmationService.confirm({
      message: message,
      header: header,
      icon: "fa fa-trash",
      accept: () => {
        this.delete(candidate);
      },
    });
  }

  public delete(candidate: Candidate) {
    this.candidateService
      .deleteCandidate(candidate.id)
      .toPromise()
      .then(
        (response) => {
          this.msgs = [];
          this.msgs.push({ severity: "success", summary: "deleted" });
          this.getCandidate();
        },
        (error) => {
          this.msgs = [];
          this.msgs.push({ severity: "error", summary: "error" });
        }
      );
  }

  public activeCandidate(candidate: Candidate) {
    this.putCandidate(candidate);
  }

  public putCandidate(values: Candidate) {
    const param = {
      activated: values.activated,
    };
    if (values) {
      const promise = this.candidateService.updateCandidate(values.id, param);
      this.promiseForm = promise.toPromise().then(
        (response) => {
          this.translate.get("saved").subscribe((res: string) => {
            this.msgs = [];
            this.msgs.push({ severity: "success", summary: res });
          });
        },
        (error) => {
          this.msgs.push({ severity: "error", summary: "Error" });
        }
      );
    }
  }

  public filter(values) {
    this.page = 1;
    this.first = 0;

    var query = this.searchFilter.nativeElement.value;
    if (query != null && query != "") query = query.replace(/\s/g, "%");

    // if (values.age_min_filter === null || values.age_min_filter === '' || values.age_min_filter === undefined)
    //     values.age_min_filter = this.ageMin;

    // if (values.age_max_filter === null || values.age_max_filter === '' || values.age_max_filter === undefined)
    //     values.age_max_filter = this.ageMax;

    this.buildingFilter(values);

    this.getCandidate(query);
  }

  public buildingFilter(values) {
    this.filters = [];

    if (
      values.gender_filter !== null &&
      values.gender_filter !== "" &&
      values.gender_filter !== undefined
    )
      this.filters.push({ key: "gender-lk", value: values.gender_filter });

    if (
      values.civil_status_filter !== null &&
      values.civil_status_filter !== "" &&
      values.civil_status_filter !== undefined
    )
      this.filters.push({
        key: "civil_status-lk",
        value: values.civil_status_filter,
      });

    if (
      values.driving_license_filter !== null &&
      values.driving_license_filter !== "" &&
      values.driving_license_filter !== undefined
    )
      this.filters.push({
        key: "driving_license-lk",
        value: values.driving_license_filter,
      });

    if (
      values.level_education_filter !== null &&
      values.level_education_filter !== "" &&
      values.level_education_filter !== undefined
    )
      this.filters.push({
        key: "eduacational_level-lk",
        value: values.level_education_filter,
      });

    if (
      values.residence_city_id_filter !== null &&
      values.residence_city_id_filter !== "" &&
      values.residence_city_id_filter !== undefined
    )
      this.filters.push({
        key: "residence_city-lk",
        value: values.residence_city_id_filter.id,
      });

    if (
      values.salary_aspiration_filter.min !== null &&
      values.salary_aspiration_filter.min !== "" &&
      values.salary_aspiration_filter.min !== undefined
    )
      this.filters.push({
        key: "salary_aspiration-min",
        value: values.salary_aspiration_filter.min,
      });

    if (
      values.salary_aspiration_filter.max !== null &&
      values.salary_aspiration_filter.max !== "" &&
      values.salary_aspiration_filter.max !== undefined
    )
      this.filters.push({
        key: "salary_aspiration-max",
        value: values.salary_aspiration_filter.max,
      });

    let date_start, date_end;

    if (
      values.age_min_filter !== null &&
      values.age_min_filter !== "" &&
      values.age_min_filter !== undefined
    ) {
      date_end = this.getDateFromAge(values.age_min_filter, true, 0);
      this.filters.push({ key: "date_birth-max", value: date_end });
    }

    if (
      values.age_max_filter !== null &&
      values.age_max_filter !== "" &&
      values.age_max_filter !== undefined
    ) {
      date_start = this.getDateFromAge(values.age_max_filter, false, 1);
      this.filters.push({ key: "date_birth-min", value: date_start });
    }

    if (values.created_botzy_filter != "")
      this.filters.push({
        key: "created_by_botzy",
        value: values.created_botzy_filter,
      });

    if (
      values.candidate_has_user_filter !== null &&
      values.candidate_has_user_filter !== "" &&
      values.candidate_has_user_filter !== undefined
    )
      this.filters.push({
        key: "candidate_has_user",
        value: values.candidate_has_user_filter,
      });

    if (
      values.candidate_has_work_experience_filter !== null &&
      values.candidate_has_work_experience_filter !== "" &&
      values.candidate_has_work_experience_filter !== undefined
    )
      this.filters.push({
        key: "candidate_has_work_experience",
        value: values.candidate_has_work_experience_filter,
      });

    if (
      values.job_status_filter !== null &&
      values.job_status_filter !== "" &&
      values.job_status_filter !== undefined
    )
      this.filters.push({ key: "job_status", value: values.job_status_filter });

    if (
      values.profession_id_filter !== null &&
      values.profession_id_filter !== "" &&
      values.profession_id_filter !== undefined
    )
      this.filters.push({
        key: "profession_id-lk",
        value: values.profession_id_filter.id,
      });

    if (
      values.work_area_filter !== null &&
      values.work_area_filter !== "" &&
      values.work_area_filter !== undefined
    )
      this.filters.push({
        key: "work_area-lk",
        value: values.work_area_filter,
      });

    this.filters.push({ key: "business_id", value: "1" });
  }

  public getDateFromAge(age_data: number, end_day: boolean, gap_year: number) {
    let date = new Date();
    let today_year = date.getFullYear();

    let year_in_past = today_year - age_data;

    date.setFullYear(year_in_past - gap_year);
    if (end_day) date.setHours(23, 59, 59, 999);
    else date.setHours(0, 0, 0, 0);

    return formatDate(date);
  }

  public gotoEducations(id) {
    this.router.navigate(["/pages/selection/educations"], {
      queryParams: { id_candidate: id },
    });
  }

  public gotoWorkExperiences(id) {
    this.router.navigate(["/pages/selection/work-experiences"], {
      queryParams: { id_candidate: id },
    });
  }

  public gotoCandidateComments(id) {
    this.router.navigate(["/pages/selection/candidate-comments"], {
      queryParams: { id_candidate: id },
    });
  }

  public hasPermission(permission) {
    return this.hasPermissionService.hasPermission(permission);
  }

  public closeCandidateDialog() {
    this.modNewViewDialog = false;
    this.read.setValue("");
    this.barcodeRead = "";
  }

  public paserRead(values) {
    this.barcodeRead = values.read;
    this.modNewViewDialog = true;
  }

  public updateAgeMaxOptions(age_min_form: any, age_max_form: any) {
    if (
      age_min_form == null ||
      age_min_form == "" ||
      age_min_form == undefined
    ) {
      this.ageMaxOptions = [];

      for (let i = this.ageMin; i <= this.ageMax; i++)
        this.ageMaxOptions.push({ label: i.toString() + " años", value: i });
    } else {
      this.ageMaxOptions = [];

      for (let i = age_min_form; i <= this.ageMax; i++)
        this.ageMaxOptions.push({ label: i.toString() + " años", value: i });
    }

    if (age_max_form < age_min_form)
      this.form_filter.get("age_max_filter").setValue("");
  }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/pages/candidates/candidates.component.ts